import React, { createContext, useEffect, useRef, useState } from "react";
import DashboardScreen from "./source/screens/Dashboard/DashboardScreen";
import LeadManagementScreen from "./source/screens/LeadMangement/LeadManagementScreen";
import PipelineManagementScreen from "./source/screens/PipelineManagement/PipelineManagementScreen";
import SideBar from "./source/Sidebar/SideBar";
import Login from "./source/screens/Login/Login";
import ForgotPassword from "./source/screens/ForgotPassword/ForgotPassword";
import RoleManagementTable from "./source/screens/RoleManagement/RoleManagement";
import ReportManagementTable from "./source/screens/ReportManagementTable/ReportManagementTable";
import Settings from "./source/screens/Settings/Settings";
import { BrowserRouter as Router, Routes, Route, useLocation, useNavigate } from "react-router-dom";
import AssetManagement from "./source/screens/AssetsManagement/AssetsManagement";
import Support from "./source/screens/Support/Support";
import { AiOutlineMenu } from "react-icons/ai";
import UserManagement from "./source/screens/UserManagement/UserManagement";
import TravelHistory from "./source/screens/TravelHistory/TravelHistory";
import CallHistory from "./source/screens/CallHistory/CallHistory";
import AssignLeads from "./source/screens/AssignLeads/AssignLeads";
import TaskReminder from "./source/screens/TaskReminder/TaskReminder";
import Resend from "./source/screens/Resend/Resend";
import ClientsManagement from "./source/screens/ClientsManagement/ClientsManagement";
import ClientManagmentDetail from "./source/screens/ClientsManagement/ClientManagmentDetail";
import UserDetails from "./source/screens/UserDetails/UserDetails";
import SupportRequest from "./source/screens/SupportRequest/SupportRequest";
import Transactions from "./source/screens/Transactions/Transactions";
import SubscriptionRequest from "./source/screens/SubscriptionRequest/SubscriptionRequest";
import ClientDetails from "./source/screens/ClientDetails/ClientDetails";
import { FiSearch } from "react-icons/fi";
import { IoMenu, IoNotificationsOutline } from "react-icons/io5";
import { Provider } from "react-redux";
import { persistor, Store } from "./source/store";
import { ToastContainer } from "react-toastify";
import { PersistGate } from "redux-persist/integration/react";
import StripeForm from "./source/Stripe/StripeForm";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { ACTIVETAB, refreshToken } from "./source/Actions/actions";
import AssetCreation from "./source/screens/AssetsManagement/AssetCreation";
import Bill from "./source/Components/Bill/Bill";
import ResetPassword from "./source/screens/ResetPassword/ResetPassword";
import Notification from "./source/screens/Notification/Notification";
import PrivacyPolicy from "./source/screens/PrivacyPolicy/PrivacyPolicy";
import { IoIosNotifications, IoIosNotificationsOutline } from "react-icons/io";
import { ProtectedRoute, Unauthorized } from "./source/Components/ProtectedRoute/ProtectedRoute";
import SessionExpiredModal from "./source/Components/RefreshSessionPopup/RefreshSession";

const MainLayout = () => {
  const { activeTab, singleClient, singleAdmin, role, notificationCount, Privilages } = useSelector(
    (state) => state.userReducer
  );
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const hasRefreshed = useRef(false);

  const hideSidebar =
    location.pathname === "/" ||
    location.pathname === "/forgot-password" ||
    location.pathname === "/reset-password" ||
    location.pathname === "/resend" ||
    location.pathname === "/privacy-policy";
  useEffect(() => {
    if (!hideSidebar && !hasRefreshed.current) {
      hasRefreshed.current = true;
      const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
      if (rememberMe) {
        dispatch(refreshToken());
      }
    }
  }, [hideSidebar]);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const isRestricted = Privilages?.some(
    (priv) => priv.feature === "Notifications" && priv.accessLevel === "Restricted"
  );
  return (
    <div className="flex flex-col md:flex-row ">
      {!hideSidebar && (
        <div className="md:hidden p-4 flex flex-row justify-between items-center">
          <div className=" flex items-center gap-4">
            <IoMenu className="w-8 h-8 text-gray-800 cursor-pointer" onClick={() => setIsSidebarOpen(!isSidebarOpen)} />
            {/* <FiSearch className="text-gray-400 w-5 h-5" /> */}
          </div>
          <p className=" font-medium text-sm text-gray-800 ">
            {role == "Admin" ? "Admin" : singleClient?.businessName}
          </p>
          <div className="flex items-center gap-2">
            {isRestricted ? null : (
              <div className="relative cursor-pointer">
                <IoNotificationsOutline
                  onClick={() => {
                    dispatch({
                      type: ACTIVETAB,
                      payload: "Notifications",
                    });
                    navigate("/notifications");
                  }}
                  size={24}
                  className="text-gray-700"
                />
                {notificationCount?.count > 0 && (
                  <span className="absolute -top-1 -right-1 bg-red-500 text-white text-[10px] w-4 h-4 flex items-center justify-center rounded-full">
                    {notificationCount.count}
                  </span>
                )}
              </div>
            )}
            {singleAdmin?.logo || singleClient?.logo ? (
              <img
                onClick={() => {
                  navigate("/settings");
                  dispatch({
                    type: ACTIVETAB,
                    payload: "Settings",
                  });
                }}
                src={
                  role === "Admin"
                    ? singleAdmin?.logo ||
                      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQH5sFjZPx1Yzi1b9_FpQzrxqgsjv2DPAp81Q&s"
                    : singleClient?.logo ||
                      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQH5sFjZPx1Yzi1b9_FpQzrxqgsjv2DPAp81Q&s"
                }
                className="w-10 h-10 rounded-full cursor-pointer"
                alt="User"
              />
            ) : (
              <p className="font-bold text-gray-400 text-lg w-8 h-8 bg-gray-200 rounded-full flex items-center justify-center">
                {role === "Admin" ? singleAdmin?.firstname?.slice(0, 1) : singleClient?.businessName?.slice(0, 1)}
              </p>
            )}
          </div>
        </div>
      )}
      {!hideSidebar && (
        <div
          className={`${
            isSidebarOpen ? "block" : "hidden"
          }  h-screen bg-white md:block shadow-lg z-50 md:min-w-[260px]`}
        >
          <SideBar setIsSidebarOpen={setIsSidebarOpen} isSidebarOpen={isSidebarOpen} />
        </div>
      )}
      <main className="flex-1 bg-white">
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/dashboard" element={<DashboardScreen />} />
          <Route element={<ProtectedRoute allowedRoles={["Client", "Employee"]} featureName="Lead Management" />}>
            <Route path="/lead-management" element={<LeadManagementScreen />} />
          </Route>
          <Route path="/unauthorized" element={<Unauthorized />} />

          <Route element={<ProtectedRoute allowedRoles={["Client", "Employee"]} featureName="Pipeline Management" />}>
            <Route path="/pipeline-management" element={<PipelineManagementScreen />} />
          </Route>

          <Route element={<ProtectedRoute allowedRoles={["Client", "Employee"]} featureName="Role Management" />}>
            <Route path="/role-management" element={<RoleManagementTable />} />
          </Route>

          <Route element={<ProtectedRoute allowedRoles={["Client", "Employee"]} featureName="Report Management" />}>
            <Route path="/report-management" element={<ReportManagementTable />} />
          </Route>

          <Route path="/subscription-requests" element={<SubscriptionRequest />} />
          <Route path="/settings" element={<Settings />} />

          <Route path="/assets-management/create-asset" element={<AssetCreation />} />
          <Route element={<ProtectedRoute allowedRoles={["Client", "Employee"]} featureName="Assets Management" />}>
            <Route path="/assets-management" element={<AssetManagement />} />
          </Route>

          <Route element={<ProtectedRoute allowedRoles={["Client", "Employee"]} featureName="Support" />}>
            <Route path="/support" element={<Support />} />
          </Route>

          <Route element={<ProtectedRoute allowedRoles={["Client", "Employee"]} featureName="User Management" />}>
            <Route path="/user-management" element={<UserManagement />} />
          </Route>

          <Route path="/travel-history" element={<TravelHistory />} />
          <Route path="/call-history" element={<CallHistory />} />
          <Route path="/assign-leads" element={<AssignLeads />} />
          <Route path="/tasks-&-reminders" element={<TaskReminder />} />
          <Route path="/client-management" element={<ClientsManagement />} />
          <Route element={<ProtectedRoute allowedRoles={["Client", "Employee"]} featureName="Notifications" />}>
            <Route path="/notifications" element={<Notification />} />
          </Route>

          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/client-management/details/:id" element={<ClientManagmentDetail />} />
          <Route path="/transactions" element={<Transactions />} />
          <Route path="/resend" element={<Resend />} />
          <Route path="/user-management/user-details" element={<UserDetails />} />
          <Route path="/support/:id" element={<SupportRequest />} />
          <Route path="/subscription-requests/:id" element={<ClientDetails />} />
          <Route path="/bill-status" element={<Bill />} />
          <Route path="/subscription-requests/payment" element={<StripeForm />} />
        </Routes>
      </main>
    </div>
  );
};
export const TabContext = createContext();

const App = () => {
  return (
    <Provider store={Store}>
      <PersistGate loading={null} persistor={persistor}>
        <ToastContainer />
        <SessionExpiredModal />
        <Router>
          <MainLayout />
        </Router>
      </PersistGate>
    </Provider>
  );
};

export default App;
